import { createSelector } from 'reselect'
import { createBasicSelector } from 'util/redux'
import { emptyObj } from 'util/objects'
import { emptyArr } from 'util/arrays'
import { stripDrawerIdsFromProps } from './util'

export function selectBase(state) {
  return state.drawers || emptyObj
}

export const selectDrawerStack = createBasicSelector(
  selectBase,
  drawers => drawers.drawerStack || emptyArr
)

export const selectPreviousDrawer = createSelector(
  selectDrawerStack,
  stack => (stack[0] ? stripDrawerIdsFromProps(stack[0]) : null)
)
